import CityTable from "../../../views/City";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const cityRoutes = [
  {
    menuName: MenuNames.CITY,
    path: "/cities",
    component: CityTable,
    exact: true,
  },
  {
    menuName: MenuNames.CITY,
    path: "/cities/:id(\\d+)",
    component: CityTable,
    exact: true,
  },
];

export default cityRoutes;
